<template>

  <div>
    <el-row type="flex" class="row-bg my-footer" justify="space-between">
      <!--
      <el-col :span="6">
        <h3>footer</h3>
        <p>内容</p>
      </el-col>
      <el-col :span="6">
        <h3>footer</h3>
        <p>内容</p>
      </el-col>
      <el-col :span="6">
        <h3>footer</h3>
        <p>内容</p>
        <p>内容</p>
        <p>内容</p>
      </el-col>-->
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      forcollapse: ['allsame'],
      product: {
        DojinCollection: false, //同人收藏本
        DojinPeripheral: false //同人周邊
      },
      formActive: ["thePrintTableData", "1", "2"], //['1']
      allData: {}
    };
  },
  name: "Footer",
  components: {}
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-footer {
    padding-top: 10%;
  padding-bottom: 10%;
}
</style>
